'use client';

import { useMemo } from 'react';

import type { NavigationItemProps } from '@/app/(dashboard)/_components/layout/navigation/navigation.interface';
import { navigationItems } from '@/app/(dashboard)/_components/layout/navigation/navigation-items';
import { useAccessData } from '@/hooks/use-access-data';
import type { TPermissions } from '@/types';
import { isValueEmpty } from '@/utils';

const useFilteredNavigation = () => {
  const { checkModuleAccess, checkRightsAccess } = useAccessData();

  return useMemo(() => {
    return navigationItems.reduce((acc, item) => {
      const hasMainAccess = isValueEmpty(item.moduleName)
        ? true
        : item.view === 'rights'
          ? checkRightsAccess(item.moduleName as any)
          : checkModuleAccess(item.moduleName, item.view);

      const filteredSubItems
        = item.subItems?.filter(
          (subItem) => {
            if (isValueEmpty(subItem.moduleName)) {
              return true;
            }

            return subItem.view === 'rights'
              ? checkRightsAccess(subItem.moduleName)
              : checkModuleAccess(subItem.moduleName, subItem.view);
          },
        ) || [];

      if (hasMainAccess) {
        acc.push({
          ...item,
          ...(filteredSubItems.length ? { subItems: filteredSubItems } : { subItems: undefined }),
        });
      } else if (filteredSubItems.length) {
        acc.push(...filteredSubItems);
      }

      return acc;
    }, [] as NavigationItemProps<keyof TPermissions>[]);
  }, [navigationItems, checkModuleAccess, checkRightsAccess]);
};

export default useFilteredNavigation;
